import {InlineModuleTypeEnum} from "../Views/PageView/Enums/InlineModuleTypeEnum";

export const InlineModuleMixin = {
	methods: {
		convertedHtmlArray(html: string, forms: any[], documents: any[]) {
			let result = [];
			const regex = /\[.+:.+\]/g;

			if (html.match(regex)) {
				let str = html;
				let index = 0;
				let itemId: any;

				[...str.matchAll(regex)].forEach(item => {
					result.push(str.slice(index, item.index));
					itemId = item[0].replace(/\[.+:/, '').replace(']', '');

					if (item[0].includes(InlineModuleTypeEnum.FORM) && forms !== undefined) {
						result.push({type: InlineModuleTypeEnum.FORM, items: forms[itemId]});
					} else if (item[0].includes(InlineModuleTypeEnum.DOCUMENT) && documents !== undefined) {
						result.push({type: InlineModuleTypeEnum.DOCUMENT, items: documents[itemId]});
					}

					// @ts-ignore
					index = item.index + item[0].length;
				});
				result.push(str.slice(index));

			} else {
				result.push(html);
			}
			return result;
		},
	},
};
